<h2>{{title}}</h2>
<div *ngFor="let link of links" class="link">
  <a href="{{link.url}}">{{link.name}}</a>
</div>
